import { Fragment } from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import { NavLink } from "react-router-dom";
// import { withStyles } from "@mui/styles";

import { List, ListItem } from "@mui/material";

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(3),
    overflowX: "auto",
  },
});

function ResultDetails(props) {
  let addResultDetails = props.searchResultDetails[1];
  let postResultDetails = props.searchResultDetails[2];
  const addressList = addResultDetails.map((addResultDetails, i) => (
    <ListItem key={i}>
      {addResultDetails ? (
        <Fragment>
          <NavLink
            to={"/location/dashboard/" + addResultDetails.id}
            className="Nav_link"
          >
            {addResultDetails.address + " - " + addResultDetails.name}
          </NavLink>
        </Fragment>
      ) : null}
    </ListItem>
  ));

  const postalList = postResultDetails.map((postResultDetails, i) => (
    <ListItem key={i}>
      {postResultDetails ? (
        <Fragment>
          <NavLink
            to={"/location/dashboard/" + postResultDetails.id}
            className="Nav_link"
          >
            {postResultDetails.address + " - " + postResultDetails.name}
          </NavLink>
        </Fragment>
      ) : null}
    </ListItem>
  ));
  return (
    <Container maxWidth="lg">
      <Grid container spacing={3}>
        <Grid item xs={12} md={8} lg={5}>
          {addResultDetails ? (
            <div>
              <h3>Address Matches</h3>
              <List>{addressList}</List>
            </div>
          ) : null}
          {postResultDetails ? (
            <div>
              <h3>Postal Code Matches</h3>
              <List>{postalList}</List>
            </div>
          ) : null}
        </Grid>
      </Grid>
    </Container>
  );
}

// export default withStyles(styles, { withTheme: true })(ResultDetails);
export default ResultDetails